import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import { inchesToFeet } from "legacy/helpers.es6"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

class AssignmentSearchForm extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      assignmentSearch: "",
      filteredResults: [],
      filteredSpaces: [],
    }
    this.handleSearch = this.handleSearch.bind(this)
    this.handleWindowClick = this.handleWindowClick.bind(this)
    this.searchResultsRef = null
    this.setSearchResultsRef = (element) => {
      this.searchResultsRef = element
    }
  }

  componentDidMount() {
    window.addEventListener("click", this.handleWindowClick)
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.handleWindowClick)
  }

  handleWindowClick(event) {
    if (
      this.searchResultsRef &&
      !this.searchResultsRef.contains(event.target)
    ) {
      this.setState({
        assignmentSearch: "",
        filteredResults: [],
        filteredSpaces: [],
      })
      if (this.isMarinaMapView()) {
        this.props.setGlobalState({
          searchResults: [],
          highlightedSpace: null,
        })
      }
    }
  }

  isMarinaMapView() {
    return this.props.viewType.includes("map")
  }

  handleMouseEnter(object) {
    if (this.isMarinaMapView()) {
      this.props.setGlobalState({ highlightedSpace: object })
    }
  }

  matchValue(object, value, params) {
    return params.some((key) => {
      const lowerCaseValue = value.toLowerCase()
      const lowerCaseFieldValue = _.get(object, key, "").toLowerCase()
      return lowerCaseFieldValue.includes(lowerCaseValue)
    })
  }

  handleSearch(event) {
    const value = event.target.value
    let filteredResults = []
    const filteredSpaces = this.props.searchFormData.filter((space) => {
      if (space.assignments.length > 0) {
        let assignmentsArray = space.assignments
        if (this.props.viewType.includes("map")) {
          assignmentsArray = space.assignments.filter(
            (assignment) => !assignment.checked_out_at
          )
        }
        const assignments = assignmentsArray.filter((assignment) => {
          return this.matchValue(assignment, value, [
            "boat_name",
            "contact_name",
          ])
        })
        if (assignments.length > 0) {
          filteredResults = [...filteredResults, ...assignments]
          return true
        }
      }
      if (space.placeholders && space.placeholders.length > 0) {
        const placeholders = space.placeholders.filter((placeholder) => {
          return this.matchValue(placeholder, value, ["note"])
        })
        if (placeholders.length > 0) {
          filteredResults = [...filteredResults, ...placeholders]
          return true
        }
      }
      if (space.spaceNotes && space.spaceNotes.length > 0) {
        const spaceNotes = space.spaceNotes.filter((spaceNote) => {
          return this.matchValue(spaceNote, value, ["note"])
        })
        if (spaceNotes.length > 0) {
          filteredResults = [...filteredResults, ...spaceNotes]
          return true
        }
      }
      return false
    })
    if (value) {
      this.setState({
        filteredSpaces,
        filteredResults,
      })
      if (this.isMarinaMapView()) {
        this.props.setGlobalState({ searchResults: filteredSpaces })
      }
    } else {
      this.setState({
        filteredSpaces: [],
        filteredResults: [],
      })
      if (this.isMarinaMapView()) {
        this.props.setGlobalState({ searchResults: [] })
      }
    }
    this.setState({ assignmentSearch: value })
  }

  handleSearchItemClick(space, object) {
    if (this.isMarinaMapView()) {
      this.props.handleMarinaMapSpaceClick(space, [object])
    } else if (object.type === "assignment") {
      this.props.loadReservationForSidebar(object.reservation_id, space)
    } else {
      this.props.setPlaceholder(object, space)
    }
    this.setState({
      filteredSpaces: [],
      filteredResults: [],
      assignmentSearch: "",
    })
    if (this.isMarinaMapView()) {
      this.props.setGlobalState({ searchResults: [], highlightedSpace: null })
    }
  }

  renderAssignment(assignment, index) {
    const spaceWithAssignment = this.state.filteredSpaces.find((space) =>
      space.assignments.includes(assignment)
    )
    return (
      <div
        onMouseEnter={() => this.handleMouseEnter(spaceWithAssignment)}
        onMouseLeave={() =>
          this.isMarinaMapView() &&
          this.props.setGlobalState({ highlightedSpace: null })
        }
        key={index}
        className="cursor-pointer px-4 py-2 hover:bg-blue-50"
        onClick={() =>
          this.handleSearchItemClick(spaceWithAssignment, assignment)
        }
      >
        <span className="text-lg">{assignment.boat_name}</span>
        <div className="text-muted flex w-full justify-between">
          <span>Captain: {assignment.contact_name}</span>
          <span>Res ID: #{assignment.reservation_id}</span>
        </div>
      </div>
    )
  }

  renderPlaceholder(placeholder, index) {
    const spaceWithPlaceholder = this.state.filteredSpaces.find(
      (space) => space.placeholders && space.placeholders.includes(placeholder)
    )
    return (
      <div
        onMouseEnter={() => this.handleMouseEnter(spaceWithPlaceholder)}
        onMouseLeave={() =>
          this.isMarinaMapView() &&
          this.props.setGlobalState({ highlightedSpace: null })
        }
        key={index}
        className="cursor-pointer px-4 py-2 hover:bg-blue-50"
        onClick={() =>
          this.handleSearchItemClick(spaceWithPlaceholder, placeholder)
        }
      >
        <span className="text-lg">
          <i className="icon icon-thumb-tack" /> {spaceWithPlaceholder.name}
        </span>
        <div className="text-muted flex w-full justify-between">
          <span className="w-1/2 overflow-hidden truncate">
            Note: {placeholder.note}
          </span>
          <span>LOA: {inchesToFeet(placeholder.length_overall)} ft</span>
        </div>
      </div>
    )
  }

  renderSpaceNote(spaceNote, index) {
    const spaceWithSpaceNote = this.state.filteredSpaces.find(
      (space) => space.spaceNotes && space.spaceNotes.includes(spaceNote)
    )
    return (
      <div
        key={index}
        className="cursor-pointer px-4 py-2 hover:bg-blue-50"
        onClick={() =>
          this.handleSearchItemClick(spaceWithSpaceNote, spaceNote)
        }
      >
        <span className="text-lg">
          <i className="icon icon-clipboard-pencil" /> {spaceWithSpaceNote.name}
        </span>
        <div className="text-muted flex w-full justify-between">
          <span className="w-3/4 overflow-hidden truncate">
            Note: {spaceNote.note}
          </span>
        </div>
      </div>
    )
  }

  renderSearchResults() {
    const { filteredResults, assignmentSearch } = this.state
    const hasResults = filteredResults.length > 0
    if (hasResults) {
      return (
        <div
          className="absolute z-50 mt-12 w-full overflow-auto rounded-b bg-white py-2 shadow-md"
          style={{ maxHeight: "70vh" }}
        >
          {filteredResults.slice(0, 10).map((result, index) => {
            if (result.type === "assignment") {
              return this.renderAssignment(result, index)
            } else if (result.type === "placeholder") {
              return this.renderPlaceholder(result, index)
            } else {
              return this.renderSpaceNote(result, index)
            }
          })}
        </div>
      )
    } else if (assignmentSearch) {
      return (
        <div className="absolute z-50 mt-12 w-full rounded-b bg-white p-6 text-center shadow-md">
          No boat name, captain, or note matches for &quot;{assignmentSearch}
          &quot;
        </div>
      )
    }
  }

  render() {
    return (
      <div className="relative flex h-10 w-full" ref={this.setSearchResultsRef}>
        <FormGroup
          inputType="text-icon"
          iconText="icon-search-fa"
          name="assignmentSearch"
          onChange={this.handleSearch}
          value={this.state.assignmentSearch}
          placeholder="Search by boat name, captain, or note"
          className="w-full"
        />
        {this.renderSearchResults()}
      </div>
    )
  }
}

AssignmentSearchForm.propTypes = {
  handleMarinaMapSpaceClick: PropTypes.func,
  loadReservationForSidebar: PropTypes.func.isRequired,
  searchFormData: PropTypes.array.isRequired,
  setGlobalState: PropTypes.func,
  setPlaceholder: PropTypes.func.isRequired,
  viewType: PropTypes.string.isRequired,
}

export default AssignmentSearchForm
